// extracted by mini-css-extract-plugin
module.exports = {"addFeeForm":"AddFeeType_addFeeForm__3S49u","formRow":"AddFeeType_formRow__3LvLT","saveFee":"AddFeeType_saveFee__1c9N3","saveButton":"AddFeeType_saveButton__26vvm"};